import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';

// Simple CalloutBanner component that can be dismissed and remembers dismissal in localStorage
export default function CalloutBanner({ storageKey, variant, children }) {
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (storageKey) {
      const wasDismissed = localStorage.getItem(storageKey);
      if (wasDismissed === 'true') {
        setDismissed(true);
      }
    }
  }, [storageKey]);

  const handleDismiss = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    setDismissed(true);
    if (storageKey) {
      localStorage.setItem(storageKey, 'true');
    }
  };

  if (dismissed) {
    return null;
  }

  const variantClass = variant ? `mp-callout-banner--${variant}` : 'mp-callout-banner--default';

  return (
    <Row className="mb-3">
      <Col md={12}>
        <div className={`mp-callout-banner ${variantClass}`}>
          <div className="mp-callout-banner__glow" />
          <a
            href="javascript:void(0)"
            className="mp-callout-banner__dismiss"
            onClick={handleDismiss}
            aria-label="Dismiss"
          >
            &times;
          </a>
          <div className="mp-callout-banner__inner">
            {typeof children === 'function' ? children() : children}
          </div>
        </div>
      </Col>
    </Row>
  );
}
